import api from '@/services/utils/base';
import store from '@/store';

export default class Offer {
  get(id: string) {
    return api.get(`offers/${id}`).then((res)=>{
      return Promise.resolve(res.data.payload);
    })
  }

  getName(id: string) {
    return api.get(`offers/name/${id}`);
  }

  postCreate(payload: object) {
    return api.post('offers', payload);
  }

  getList(params:any) {
    const newParams = {...params}
    const workspaceId = newParams.workspaceId
    delete newParams.workspaceId;
    return api
      .get('offers', {params:{
          ...newParams,
          workspaceIds:[...new Set([workspaceId,...store.getters.allPublicWorkspacesIds])]
        }
      })
      .then((res: any) => {
        return Promise.resolve(res.data.payload);
      })
      .catch((err: any) => {
        return Promise.reject(err);
      });
  }

  putUpdate(id: string, payload: object) {
    return api.put(`offers/${id}`, payload);
  }

  delete(id: string) {
    return api.delete(`offers/${id}`);
  }

  postArchive(payload: object) {
    return api.post('offers/archive', payload);
  }

  postRestore(payload: object) {
    return api.post('offers/restore', payload);
  }

  postDuplicate(payload: object) {
    return api.post('offers/duplicate', payload);
  }

  getCount(payload: object) {
    return api.get('offers/count', payload);
  }

  import(data: any) {
    return api.post('offers/import', data);
  }

  bulkUpdate(workspaceId: string, payload: object) {
    return api.put(`/offers/workspace/${workspaceId}/bulk-update`, payload);
  }
  
  updateStoreCache({workspaceId, countryId}) {
    return api.get('offers', {
      params:{
        status:'active',
        limit:'200',
        columns:[ 'id', 'name', 'countryId', 'workspaceId', 'affiliateNetworkId' ,'affiliateNetworkName', 'countryName', 'url'],
        orderBy:'updated',
        orderDirection:'desc',
        workspaceIds:[...new Set([workspaceId,...store.getters.allPublicWorkspacesIds])],
        ...(countryId!==0 && {countryId})
      }
    }).then((res)=>{
      store.commit('updateOffersCache', {
        workspaceId,
        countryId,
        data:res.data.payload
      });
      return Promise.resolve(res.data.payload);
    })
  }

  populateStoreCache() {
    return api.get('offers', {
      params:{
        status:'active',
        limit:'200',
        columns:[ 'id', 'name' , 'countryId', 'workspaceId',  'affiliateNetworkId' ,'affiliateNetworkName', 'countryName', 'url'],
        orderBy:'updated',
        orderDirection:'desc'
      }
    }).then((res)=>{
      store.commit('populateOffersCache', res.data.payload);
      return Promise.resolve(res.data.payload);
    })
  }
}
